
import { message } from "ant-design-vue";
import { RuleObject } from "ant-design-vue/lib/form";

/**
 * 
 * @description 对合并行的处理
 * @param {String} key 需要合并列的key
 * @param {Array} data 表格数据
 * @param return Array
 */
export function rowSpanFun(key: string, data: any[]) {
  const arr = data
    .reduce((result, item) => {
      if (result.indexOf(item[key]) < 0) {
        result.push(item[key]);
      }
      return result;
    }, [])
    .reduce((result: any[], keys: any) => {
      const children = data.filter((item) => item[key] === keys);
      result = result.concat(
        children.map((item, index) => ({
          ...item,
          [`RowSpan`]: index === 0 ? children.length : 0,
        }))
      );
      return result;
    }, []);
  return arr;
}

/**
 * 
 * @description 邮箱校验
 */
export const emailValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入邮箱');
  }
  if (/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('邮箱格式不正确');
}
/**
 * 
 * @description 手机校验
 */
export const phoneValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入手机号');
  }
  if (/^1[23456789]\d{9}$/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('请输入正确的手机号');
}
/**
 * 
 * @description 密码校验
 */
export const passwordValidate = (rule: RuleObject, value: string) => {
  if (value === '') {
    return Promise.reject('请输入密码');
  }
  if(value.length >=8 && /^(?![^a-zA-Z]+$)(?!\D+$)/.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('密码需要包含数字和字母且长度大于等于8位');
}

/**
 * 
 * @description 序列校验
 */
 export const sequenceValidate = (rule: RuleObject, value: string) => {
  const reg = /^(a|t|c|g)*$/i
  if (value === '') {
    return Promise.resolve();
  }
  if(reg.test(value)) {
    return Promise.resolve();
  }
  return Promise.reject('请输入atcg');
}

// 深拷贝
export function deepClone(source: any) {
  if (!source || typeof source !== 'object') {
    return source
    // throw new Error('error arguments', 'shallowClone')
  }
  const targetObj:any = Array.isArray(source) ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * json数组去重
 * @param {Array} array 需要去重的数组
 * @param {String} key  根据key字段去重
 */
 
 export function uniqueArray(array: Array<any>, key: string) {
  const result = [array[0]]
  for (let i = 1; i < array.length; i++) {
    const item = array[i]
    let repeat = false
      for (let j = 0; j < result.length; j++) {
          if (item[key] === result[j][key]) {
              repeat = true
              break
          }
      }
      if (!repeat) {
          result.push(item);
      }
  }
  return result
}
export const getRemoveBlankLines = <T>(data: T[]) => {
  const arr: T[] = []
  data.forEach(el => {
    let _flag = false
    for (const key in el) {
      // 当前key存在值
      if(el[key]) {
        _flag = true
      }
    }
    // 当前key存在值 跳出循环 存入数组
    if(_flag) {
      arr.push(el)
    }
  });
  return arr
}
/**
 * 重复校验
 * @param {Array} array 
 * @param {String} key  根据key字段查重
 */
export const repeatValidator = (data: any[], key: string) => {
  // 校验基因名称是否重复
  let _flag = true
  const arr =  data.map((item: any) => item[key]) // 所有key 的集合
  const arrSet = Array.from(new Set(arr)) // 去掉重复的数据
  if(arrSet.length < arr.length) {
    if(key === 'genename') {
      message.error('基因名称不能重复');
    } else if(key === 'sequence_des') {
      message.error('序列不能重复');
    }
    _flag = false
  } else {
    _flag = true
  }
  return _flag
}
// 
export const sequenceDesValidator = (value: any, callback: any) => {
  const reg = /^[a-z*]+$/i
  if(!value) {
    callback(false)
    return
  }
  if(!reg.test(value)) {
    callback(false)
    return
  }
  callback(true)
}
// 校验序列
export const sequenceValidator = (value: any, callback: any) => {
  const reg = /^[a-z*]+$/i
  if(!value) {
    callback(true)
    return
  }
  if(!reg.test(value)) {
    callback(false)
    return
  }
  callback(true)
}
// 序列展示转换
export const showTextSequence = (value: string) => {
  let htmlStr = ''
  let int = value.toUpperCase() 
  while (int.length > 10) {
    htmlStr = htmlStr + ',' + int.slice(0,10)
    int = int.length > 10 ? int.slice(10,int.length) : int.slice(0,10)
    if(int.length <= 10) {
      htmlStr = htmlStr + ',' + int.slice(0,10)
    }
  }
  if(value.length <= 10) {
    htmlStr = value.toUpperCase() 
  }
  htmlStr = htmlStr.includes(',') ? htmlStr.slice(1, htmlStr.length) : htmlStr
  const htmlStrArr = htmlStr.split(',') // 转换数组后进行分行拆分
  let result = '' // 保存最终字符串
  let num = 0
  htmlStrArr.forEach((el: string, index: number) => {
    if (index === 0) {
      num++
      result = `<span style="display: inline-block;width: 80px;">${num}</span>` + '&nbsp;&nbsp;' + el
    } else if (index !== 0 && index%4==0) { // 4的倍数可以拆分到下一行
      num++
      result = result + '</br>' + `<span style="display: inline-block;width: 80px;">${num}</span>` + '&nbsp;&nbsp;' + el
    } else {
      result = result + '&nbsp;&nbsp;' + el
    }
  });
  return result
}

/**
 * 导出文件
 * @param blob 文件Blob
 * @param name 文件名
 * @param suffix 文件后缀 默认.xlsx
 */
export function exportFile(blob: Blob,name: string, suffix = '.xlsx') {
  return new Promise<void>((resolve, reject) => {
    try {
      console.log(blob)
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.target = '_blank'
      link.href = url
      link.download = name + suffix;
      link.click()
      URL.revokeObjectURL(url)
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
// 是否是纯数值
export const numReturn = (value: any) => {
  const reg = /^(-)?[0-9]+([.][0-9]{1,})?$/
  if (!reg.test(value)) return false
  return true
}

//处理值是值不为数值直接返回 否则处理数值
export function handleNumber(value: any, mantissa = 2) {
  const reg = /^(-)?[0-9]+([.][0-9]{1,})?$/
  if (!reg.test(value)) {
    return value
  }
  if (typeof value == "string") {
    value = Number(value);
  }
  if (!value) {
    value = 0
  }
  value = value.toFixed(mantissa);
  return value
}
// 获取url参数
export function queryURLParams(url: string) {
  const urlStr = url.split("?")[1];
  if(!urlStr) return {}
  const obj:any = {}; // 声明参数对象
  const arr = urlStr.split("&"); // 以&符号分割为数组
  for (let i = 0; i < arr.length; i++) {
    const arrNew = arr[i].split("="); // 以"="分割为数组
    obj[arrNew[0]] = arrNew[1];
  }
  return obj;
}

// 反向互补
export const reverseComplement = (seq: string): string => {
  if (!seq || typeof seq !== 'string') {
    return ''
  }
  const complement: Record<string, string> = {
    'A': 'T', 'T': 'A', 'G': 'C', 'C': 'G',
    'a': 't', 't': 'a', 'g': 'c', 'c': 'g'
  }
  const cleanedSeq = seq.split('').reverse().map(char => complement[char] || char).join('')
  return cleanedSeq
}
//引物序列
export const primerData = [
  {
    "no": 1,
    "primer_name": "M13F-77",
    "primer_sequence": "GATGTGCTGCAAGGCGATTA",
    "reverse_sequence": "TAATCGCCTTGCAGCACATC"
  },
  {
    "no": 2,
    "primer_name": "M13R-88",
    "primer_sequence": "TTATGCTTCCGGCTCGTATG",
    "reverse_sequence": "CATACGAGCCGGAAGCATAA"
  },
  {
    "no": 3,
    "primer_name": "M13F-47",
    "primer_sequence": "CGCCAGGGTTTTCCCAGTCACGAC",
    "reverse_sequence": "GTCGTGACTGGGAAAACCCTGGCG"
  },
  {
    "no": 4,
    "primer_name": "M13R-48",
    "primer_sequence": "AGCGGATAACAATTTCACACAGGA",
    "reverse_sequence": "TCCTGTGTGAAATTGTTATCCGCT"
  },
  {
    "no": 5,
    "primer_name": "M13F",
    "primer_sequence": "TGTAAAACGACGGCCAGT",
    "reverse_sequence": "ACTGGCCGTCGTTTTACA"
  },
  {
    "no": 6,
    "primer_name": "M13R",
    "primer_sequence": "CAGGAAACAGCTATGACC",
    "reverse_sequence": "GGTCATAGCTGTTTCCTG"
  },
  {
    "no": 7,
    "primer_name": "3-AOX",
    "primer_sequence": "GCAAATGGCATTCTGACATCC",
    "reverse_sequence": "GGATGTCAGAATGCCATTTGC"
  },
  {
    "no": 8,
    "primer_name": "5-AOX",
    "primer_sequence": "GACTGGTTCCAATTGACAAG",
    "reverse_sequence": "CTTGTCAATTGGAACCAGTC"
  },
  {
    "no": 9,
    "primer_name": "Pcold-R",
    "primer_sequence": "GGGCCTGCGCATTCTCATTG",
    "reverse_sequence": "CAATGAGAATGCGCAGGCCC"
  },
  {
    "no": 10,
    "primer_name": "Pcold-F",
    "primer_sequence": "cagtgtagtaaggcaagtcc",
    "reverse_sequence": "ggacttgccttactacactg"
  },
  {
    "no": 11,
    "primer_name": "PcoldTF-F",
    "primer_sequence": "CCACTTTCAACGAGCTGATG",
    "reverse_sequence": "CATCAGCTCGTTGAAAGTGG"
  },
  {
    "no": 12,
    "primer_name": "GLp2",
    "primer_sequence": "CTTTATGTTTTTGGCGTCTTCC",
    "reverse_sequence": "GGAAGACGCCAAAAACATAAAG"
  },
  {
    "no": 13,
    "primer_name": "RVp3",
    "primer_sequence": "CTAGCAAAATAGGCTGTCCC",
    "reverse_sequence": "GGGACAGCCTATTTTGCTAG"
  },
  {
    "no": 14,
    "primer_name": "RVp4",
    "primer_sequence": "GACGATAGTCATGCCCCGCG",
    "reverse_sequence": "CGCGGGGCATGACTATCGTC"
  },
  {
    "no": 15,
    "primer_name": "PBV220F",
    "primer_sequence": "AAGAAGGGCAGCATTCAAAG",
    "reverse_sequence": "CTTTGAATGCTGCCCTTCTT"
  },
  {
    "no": 16,
    "primer_name": "PBV220R",
    "primer_sequence": "CTGCGTTCTGATTTAATCTG",
    "reverse_sequence": "CAGATTAAATCAGAACGCAG"
  },
  {
    "no": 17,
    "primer_name": "PFastBac-F",
    "primer_sequence": "aaatgataaccatctcgc",
    "reverse_sequence": "gcgagatggttatcattt"
  },
  {
    "no": 18,
    "primer_name": "PFastBac-R",
    "primer_sequence": "TTCAGGTTCAGGGGGAGGTG",
    "reverse_sequence": "CACCTCCCCCTGAACCTGAA"
  },
  {
    "no": 19,
    "primer_name": "PFastBAC-HT-F",
    "primer_sequence": "TTCATACCGTCCCACCATCG",
    "reverse_sequence": "CGATGGTGGGACGGTATGAA"
  },
  {
    "no": 20,
    "primer_name": "PET32a-seqR",
    "primer_sequence": "CTGGTTCTGGCCATATGCAC",
    "reverse_sequence": "GTGCATATGGCCAGAACCAG"
  },
  {
    "no": 21,
    "primer_name": "PET43.1a-seqR",
    "primer_sequence": "ACACTACCATCGGCGCTACG",
    "reverse_sequence": "CGTAGCGCCGATGGTAGTGT"
  },
  {
    "no": 22,
    "primer_name": "PJET1.2-seqR",
    "primer_sequence": "TATACAGCCTGAAAATCTTG",
    "reverse_sequence": "CAAGATTTTCAGGCTGTATA"
  },
  {
    "no": 23,
    "primer_name": "PJET1.2-seqF",
    "primer_sequence": "TGTGCCTGAACACCATATCC",
    "reverse_sequence": "GGATATGGTGTTCAGGCACA"
  },
  {
    "no": 24,
    "primer_name": "PTGE5-seqF",
    "primer_sequence": "CCGATCTGGCCATACACTTG",
    "reverse_sequence": "CAAGTGTATGGCCAGATCGG"
  },
  {
    "no": 25,
    "primer_name": "PTGE5-seqR",
    "primer_sequence": "CATATGTCCTTCCGAGTGAG",
    "reverse_sequence": "CTCACTCGGAAGGACATATG"
  },
  {
    "no": 26,
    "primer_name": "U6-F（U6-5'）",
    "primer_sequence": "GGACTATCATATGCTTACCG",
    "reverse_sequence": "CGGTAAGCATATGATAGTCC"
  },
  {
    "no": 27,
    "primer_name": "U6",
    "primer_sequence": "TACGATACAAGGCTGTTAGAGAG",
    "reverse_sequence": "CTCTCTAACAGCCTTGTATCGTA"
  },
  {
    "no": 28,
    "primer_name": "M13-96",
    "primer_sequence": "CCCTCATAGTTAGCGTAACG",
    "reverse_sequence": "CGTTACGCTAACTATGAGGG"
  },
  {
    "no": 29,
    "primer_name": "M13-75",
    "primer_sequence": "GATGCCGGGAGCAGACAAGC",
    "reverse_sequence": "GCTTGTCTGCTCCCGGCATC"
  },
  {
    "no": 30,
    "primer_name": "M13F-75",
    "primer_sequence": "gatgccgggagcagacaagc",
    "reverse_sequence": "gcttgtctgctcccggcatc"
  },
  {
    "no": 31,
    "primer_name": "M13-76",
    "primer_sequence": "GTGAGCGAGGAAGCGGAAGA",
    "reverse_sequence": "TCTTCCGCTTCCTCGCTCAC"
  },
  {
    "no": 32,
    "primer_name": "siRNA-5'",
    "primer_sequence": "cctccgatcgttgtcagaag",
    "reverse_sequence": "cttctgacaacgatcggagg"
  },
  {
    "no": 33,
    "primer_name": "Amp-F",
    "primer_sequence": "ATAATACCGCGCCACATAGC",
    "reverse_sequence": "GCTATGTGGCGCGGTATTAT"
  },
  {
    "no": 34,
    "primer_name": "pET-seqF",
    "primer_sequence": "GGCCCCAAGGGGTTATGCTAGT",
    "reverse_sequence": "ACTAGCATAACCCCTTGGGGCC"
  },
  {
    "no": 35,
    "primer_name": "pET-seqR",
    "primer_sequence": "GATCCCGCGAAATTAATACG",
    "reverse_sequence": "CGTATTAATTTCGCGGGATC"
  },
  {
    "no": 36,
    "primer_name": "pENTR4-seqF",
    "primer_sequence": "AGCAGAAGGCCATCCTGACG",
    "reverse_sequence": "CGTCAGGATGGCCTTCTGCT"
  },
  {
    "no": 37,
    "primer_name": "pENTR4-seqR",
    "primer_sequence": "GTGCAATGTAACATCAGAGA",
    "reverse_sequence": "TCTCTGATGTTACATTGCAC"
  },
  {
    "no": 38,
    "primer_name": "pQE30-seqF",
    "primer_sequence": "TGAGCGGATAACAATTTCAC",
    "reverse_sequence": "GTGAAATTGTTATCCGCTCA"
  },
  {
    "no": 39,
    "primer_name": "pQE30-seqR",
    "primer_sequence": "CAACCGAGCGTTCTGAACAA",
    "reverse_sequence": "TTGTTCAGAACGCTCGGTTG"
  },
  {
    "no": 40,
    "primer_name": "puc57-1.8k-SeqF ",
    "primer_sequence": "GAAGCATTTATCAGGGTTAT",
    "reverse_sequence": "ATAACCCTGATAAATGCTTC"
  },
  {
    "no": 41,
    "primer_name": "puc57-1.8k-SeqR ",
    "primer_sequence": "GGCGGAGCCTATGGAAAAAC",
    "reverse_sequence": "GTTTTTCCATAGGCTCCGCC"
  },
  {
    "no": 42,
    "primer_name": "pGEX-5'",
    "primer_sequence": "GGGCTGGCAAGCCACGTTTGGTG",
    "reverse_sequence": "CACCAAACGTGGCTTGCCAGCCC"
  },
  {
    "no": 43,
    "primer_name": "pGEX-3'",
    "primer_sequence": "CCGGGAGCTGCATGTGTCAGAGG",
    "reverse_sequence": "CCTCTGACACATGCAGCTCCCGG"
  },
  {
    "no": 44,
    "primer_name": "pCMV-F",
    "primer_sequence": "TCTAAAAGCTGCGGAATTGT",
    "reverse_sequence": "ACAATTCCGCAGCTTTTAGA"
  },
  {
    "no": 45,
    "primer_name": "pCMV-R ",
    "primer_sequence": "TCCAAACTCATCAATGTATC",
    "reverse_sequence": "GATACATTGATGAGTTTGGA"
  },
  {
    "no": 46,
    "primer_name": "EBV-R",
    "primer_sequence": "GTGGTTTGTCCAAACTCATC",
    "reverse_sequence": "GATGAGTTTGGACAAACCAC"
  },
  {
    "no": 47,
    "primer_name": "T3",
    "primer_sequence": "ATTAACCCTCACTAAAGGGA",
    "reverse_sequence": "TCCCTTTAGTGAGGGTTAAT"
  },
  {
    "no": 48,
    "primer_name": "T7",
    "primer_sequence": "TAATACGACTCACTATAGGG",
    "reverse_sequence": "CCCTATAGTGAGTCGTATTA"
  },
  {
    "no": 49,
    "primer_name": "T7T",
    "primer_sequence": "TGCTAGTTATTGCTCAGCGG",
    "reverse_sequence": "CCGCTGAGCAATAACTAGCA"
  },
  {
    "no": 50,
    "primer_name": "3-AD ",
    "primer_sequence": "AGATGGTGCACGATGCACAG",
    "reverse_sequence": "CTGTGCATCGTGCACCATCT"
  },
  {
    "no": 51,
    "primer_name": "3-BD",
    "primer_sequence": "TAAGAGTCACTTTAAAATTTGTATAC",
    "reverse_sequence": "GTATACAAATTTTAAAGTGACTCTTA"
  },
  {
    "no": 52,
    "primer_name": "GAL4AD/5-AD",
    "primer_sequence": "TACCACTACAATGGATG",
    "reverse_sequence": "CATCCATTGTAGTGGTA"
  },
  {
    "no": 53,
    "primer_name": "GAL4-BD",
    "primer_sequence": "TCATCGGAAGAGAGTAG",
    "reverse_sequence": "CTACTCTCTTCCGATGA"
  },
  {
    "no": 54,
    "primer_name": "pEGFP-C-5",
    "primer_sequence": "CATGGTCCTGCTGGAGTTCGTG",
    "reverse_sequence": "CACGAACTCCAGCAGGACCATG"
  },
  {
    "no": 55,
    "primer_name": "pEGFP-C-3",
    "primer_sequence": "TATGGCTGATTATGATCAGT",
    "reverse_sequence": "ACTGATCATAATCAGCCATA"
  },
  {
    "no": 56,
    "primer_name": "S-tag",
    "primer_sequence": "GAACGCCAGCACATGGAC",
    "reverse_sequence": "GTCCATGTGCTGGCGTTC"
  },
  {
    "no": 57,
    "primer_name": "PYES2-SEQF",
    "primer_sequence": "TCTCAAGCAAGGTTTTCAGT",
    "reverse_sequence": "ACTGAAAACCTTGCTTGAGA"
  },
  {
    "no": 58,
    "primer_name": "PYES2-SEQR",
    "primer_sequence": "CGGTTTGTATTACTTCTTATTC",
    "reverse_sequence": "GAATAAGAAGTAATACAAACCG"
  },
  {
    "no": 59,
    "primer_name": "MalE",
    "primer_sequence": "GGTCGTCAGACTGTCGATGAAGCC",
    "reverse_sequence": "GGCTTCATCGACAGTCTGACGACC"
  },
  {
    "no": 60,
    "primer_name": "CYC1-Terminator",
    "primer_sequence": "GTGACATAACTAATTACATGATG",
    "reverse_sequence": "CATCATGTAATTAGTTATGTCAC"
  },
  {
    "no": 61,
    "primer_name": "pMAL-C2X-F",
    "primer_sequence": "TGCGTACTGCGGTGATCAAC",
    "reverse_sequence": "GTTGATCACCGCAGTACGCA"
  },
  {
    "no": 62,
    "primer_name": "pMAL-C2X-R",
    "primer_sequence": "CTGCAAGGCGATTAAGTTGG",
    "reverse_sequence": "CCAACTTAATCGCCTTGCAG"
  },
  {
    "no": 63,
    "primer_name": "pMal-C5X-F",
    "primer_sequence": "CCAGAAAGGTGAAATCATGC",
    "reverse_sequence": "GCATGATTTCACCTTTCTGG"
  },
  {
    "no": 64,
    "primer_name": "pMal-C5X-R",
    "primer_sequence": "GATTTGTCCTACTCAGGAGA",
    "reverse_sequence": "TCTCCTGAGTAGGACAAATC"
  },
  {
    "no": 65,
    "primer_name": "M13F-20",
    "primer_sequence": "GTAAAACGACGGCCAGT",
    "reverse_sequence": "ACTGGCCGTCGTTTTAC"
  },
  {
    "no": 66,
    "primer_name": "35S",
    "primer_sequence": "GACGCACAATCCCACTATCC",
    "reverse_sequence": "GGATAGTGGGATTGTGCGTC"
  },
  {
    "no": 67,
    "primer_name": "NOS-R",
    "primer_sequence": "AATCATCGCAAGACCGGC",
    "reverse_sequence": "GCCGGTCTTGCGATGATT"
  },
  {
    "no": 68,
    "primer_name": "pDONR207-F",
    "primer_sequence": "GGCGGATTTGTCCTACTCAG",
    "reverse_sequence": "CTGAGTAGGACAAATCCGCC"
  },
  {
    "no": 69,
    "primer_name": "pDONR207-R",
    "primer_sequence": "CTCGACGTTTCCCGTTGAAT",
    "reverse_sequence": "ATTCAACGGGAAACGTCGAG"
  },
  {
    "no": 70,
    "primer_name": "Up1",
    "primer_sequence": "GATCTCGACGCTCTCCCT",
    "reverse_sequence": "AGGGAGAGCGTCGAGATC"
  },
  {
    "no": 71,
    "primer_name": "DOWN1",
    "primer_sequence": "GATTATGCGGCCGTGTACAA",
    "reverse_sequence": "TTGTACACGGCCGCATAATC"
  },
  {
    "no": 72,
    "primer_name": "DuetUP2",
    "primer_sequence": "TTGTACACGGCCGCATAATC",
    "reverse_sequence": "GATTATGCGGCCGTGTACAA"
  },
  {
    "no": 73,
    "primer_name": "LK01-5 Primer",
    "primer_sequence": "agggatggttggttggtggg",
    "reverse_sequence": "cccaccaaccaaccatccct"
  },
  {
    "no": 74,
    "primer_name": "EF1a-F",
    "primer_sequence": "TCAAGCCTCAGACAGTGGTTC",
    "reverse_sequence": "GAACCACTGTCTGAGGCTTGA"
  },
  {
    "no": 75,
    "primer_name": "CMV-30",
    "primer_sequence": "ATAACCCCGCCCCGTTG",
    "reverse_sequence": "CAACGGGGCGGGGTTAT"
  },
  {
    "no": 76,
    "primer_name": "CMV-24",
    "primer_sequence": "TTAGGACAAGGCTGGTGG",
    "reverse_sequence": "CCACCAGCCTTGTCCTAA"
  },
  {
    "no": 77,
    "primer_name": "SP6 ",
    "primer_sequence": "ATTTAGGTGACACTATAG",
    "reverse_sequence": "CTATAGTGTCACCTAAAT"
  },
  {
    "no": 78,
    "primer_name": "CMV-F",
    "primer_sequence": "CGCAAATGGGCGGTAGGCGTG",
    "reverse_sequence": "CACGCCTACCGCCCATTTGCG"
  },
  {
    "no": 79,
    "primer_name": "CMV-R",
    "primer_sequence": "GTTCACGGTGCCCTCC",
    "reverse_sequence": "GGAGGGCACCGTGAAC"
  },
  {
    "no": 80,
    "primer_name": "5-AOX1 ",
    "primer_sequence": "GACTGGTTCCAATTGACAAGC",
    "reverse_sequence": "GCTTGTCAATTGGAACCAGTC"
  },
  {
    "no": 81,
    "primer_name": "3-AOX1 ",
    "primer_sequence": "GCAAATGGCATTCTGACATCC",
    "reverse_sequence": "GGATGTCAGAATGCCATTTGC"
  },
  {
    "no": 82,
    "primer_name": "a-factor",
    "primer_sequence": "TACTATTGCCAGCATTGCTGC",
    "reverse_sequence": "GCAGCAATGCTGGCAATAGTA"
  },
  {
    "no": 83,
    "primer_name": "PB42AD-F",
    "primer_sequence": "ACCAGCCTCTTGCTGAGTGGAGATGCC",
    "reverse_sequence": "GGCATCTCCACTCAGCAAGAGGCTGGT"
  },
  {
    "no": 84,
    "primer_name": "PB42AD-R",
    "primer_sequence": "GAAGTGTCAACAACGTATCTA",
    "reverse_sequence": "TAGATACGTTGTTGACACTTC"
  },
  {
    "no": 85,
    "primer_name": "pFlag-CMV-F",
    "primer_sequence": "GGTAGGCGTGTACGGTGG",
    "reverse_sequence": "CCACCGTACACGCCTACC"
  },
  {
    "no": 86,
    "primer_name": "pFlag-CMV-R",
    "primer_sequence": "GCACTGGAGTGGCAACTT",
    "reverse_sequence": "AAGTTGCCACTCCAGTGC"
  },
  {
    "no": 87,
    "primer_name": "pIRES2-EGFP-SEQF",
    "primer_sequence": "ATGCCCGAAGGCTACGTCCA",
    "reverse_sequence": "TGGACGTAGCCTTCGGGCAT"
  },
  {
    "no": 88,
    "primer_name": "pIRES2-EGFP-SEQR",
    "primer_sequence": "GACGTTGTGGCTGTTGTAGT",
    "reverse_sequence": "ACTACAACAGCCACAACGTC"
  },
  {
    "no": 89,
    "primer_name": "PEGFP-N-3",
    "primer_sequence": "CGTCGCCGTCCAGCTCGACCAG",
    "reverse_sequence": "CTGGTCGAGCTGGACGGCGACG"
  },
  {
    "no": 90,
    "primer_name": "PEGFP-N-5",
    "primer_sequence": "TGGGAGGTCTATATAAGCAGAG",
    "reverse_sequence": "CTCTGCTTATATAGACCTCCCA"
  },
  {
    "no": 91,
    "primer_name": "PCDNA3.1R",
    "primer_sequence": "ACAGTGGGAGTGGCACCTTC",
    "reverse_sequence": "GAAGGTGCCACTCCCACTGT"
  },
  {
    "no": 92,
    "primer_name": "PCDNA3.1F",
    "primer_sequence": "CTAGAGAACCCACTGCTTAC",
    "reverse_sequence": "GTAAGCAGTGGGTTCTCTAG"
  },
  {
    "no": 93,
    "primer_name": "Psumo-F",
    "primer_sequence": "GGCCCCTGAAGATTTGGACA",
    "reverse_sequence": "TGTCCAAATCTTCAGGGGCC"
  },
  {
    "no": 94,
    "primer_name": "Sv40-PRO-F",
    "primer_sequence": "TATTTATGCAGAGGCCGAGG",
    "reverse_sequence": "CCTCGGCCTCTGCATAAATA"
  },
  {
    "no": 95,
    "primer_name": "Sv40-PA-R",
    "primer_sequence": "GAAATTTGTGATGCTATTGC",
    "reverse_sequence": "GCAATAGCATCACAAATTTC"
  },
  {
    "no": 96,
    "primer_name": "BGH",
    "primer_sequence": "TAGAAGGCACAGTCGAGG",
    "reverse_sequence": "CCTCGACTGTGCCTTCTA"
  },
  {
    "no": 97,
    "primer_name": "H1.3F",
    "primer_sequence": "GACGTCAATGGGAGTTTGTT",
    "reverse_sequence": "AACAAACTCCCATTGACGTC"
  },
  {
    "no": 98,
    "primer_name": "GAL1-F",
    "primer_sequence": "ATTTTCGGTTTGTATTACTTC",
    "reverse_sequence": "GAAGTAATACAAACCGAAAAT"
  },
  {
    "no": 99,
    "primer_name": "GAL1-R",
    "primer_sequence": "GTTCTTAATACTAACATAACT",
    "reverse_sequence": "AGTTATGTTAGTATTAAGAAC"
  },
  {
    "no": 100,
    "primer_name": "GAL10-R",
    "primer_sequence": "GGTGGTAATGCCATGTAATATG",
    "reverse_sequence": "CATATTACATGGCATTACCACC"
  },
  {
    "no": 101,
    "primer_name": "GAL10-F",
    "primer_sequence": "GGCAAGGTAGACAAGCCGACAAC",
    "reverse_sequence": "GTTGTCGGCTTGTCTACCTTGCC"
  },
  {
    "no": 102,
    "primer_name": "V5-reverse",
    "primer_sequence": "ATCGAGACCGAGGAGAGG",
    "reverse_sequence": "CCTCTCCTCGGTCTCGAT"
  },
  {
    "no": 103,
    "primer_name": "pLXSN-F",
    "primer_sequence": "CGCCTCCTCTTCCTCCATCC",
    "reverse_sequence": "GGATGGAGGAAGAGGAGGCG"
  },
  {
    "no": 104,
    "primer_name": "pLXSN-R",
    "primer_sequence": "GTTGCTGACTAATTGAGATG",
    "reverse_sequence": "CATCTCAATTAGTCAGCAAC"
  },
  {
    "no": 105,
    "primer_name": "PCAGGS-SEQF",
    "primer_sequence": "TTCGGCTTCTGGCGTGTGAC",
    "reverse_sequence": "GTCACACGCCAGAAGCCGAA"
  },
  {
    "no": 106,
    "primer_name": "PCAGGS-SEQR",
    "primer_sequence": "TATGTCCTTCCGAGTGAGAG",
    "reverse_sequence": "CTCTCACTCGGAAGGACATA"
  },
  {
    "no": 107,
    "primer_name": "27F",
    "primer_sequence": "AGAGTTTGATCCTGGCTCAG",
    "reverse_sequence": "CTGAGCCAGGATCAAACTCT"
  },
  {
    "no": 108,
    "primer_name": "1492R",
    "primer_sequence": "TACGGCTACCTTGTACGACTT",
    "reverse_sequence": "AAGTCGTACAAGGTAGCCGTA"
  },
  {
    "no": 109,
    "primer_name": "1525R",
    "primer_sequence": "AAGGAGGTGATCCAACC",
    "reverse_sequence": "GGTTGGATCACCTCCTT"
  },
  {
    "no": 110,
    "primer_name": "NS1",
    "primer_sequence": "GTAGTCATATGCTTGTCTC",
    "reverse_sequence": "GAGACAAGCATATGACTAC"
  },
  {
    "no": 111,
    "primer_name": "NS4",
    "primer_sequence": "CTTCCGTCAATTCCTTTAAG",
    "reverse_sequence": "CTTAAAGGAATTGACGGAAG"
  },
  {
    "no": 112,
    "primer_name": "NS8",
    "primer_sequence": "TCCGCAGGTTCACCTACGGA",
    "reverse_sequence": "TCCGTAGGTGAACCTGCGGA"
  },
  {
    "no": 113,
    "primer_name": "ITS1",
    "primer_sequence": "TCCGTAGGTGAACCTGCGG",
    "reverse_sequence": "CCGCAGGTTCACCTACGGA"
  },
  {
    "no": 114,
    "primer_name": "ITS4",
    "primer_sequence": "TCCTCCGCTTATTGATATGC",
    "reverse_sequence": "GCATATCAATAAGCGGAGGA"
  },
  {
    "no": 115,
    "primer_name": "ITS5",
    "primer_sequence": "GGAAGTAAAAGTCGTAACAAGG",
    "reverse_sequence": "CCTTGTTACGACTTTTACTTCC"
  },
  {
    "no": 116,
    "primer_name": "NL1",
    "primer_sequence": "GCATATCAATAAGCGGAGGAAAAG",
    "reverse_sequence": "CTTTTCCTCCGCTTATTGATATGC"
  },
  {
    "no": 117,
    "primer_name": "NL4",
    "primer_sequence": "GGTCCGTGTTTCAAGACGG",
    "reverse_sequence": "CCGTCTTGAAACACGGACC"
  },
  {
    "no": 118,
    "primer_name": "pGL3-Basic-SeqF",
    "primer_sequence": "TTATTTTCATTACATCTGTG",
    "reverse_sequence": "CACAGATGTAATGAAAATAA"
  },
  {
    "no": 119,
    "primer_name": "pGL3-Basic-SeqR",
    "primer_sequence": "CTTCATAGCCTTATGCAGTT",
    "reverse_sequence": "AACTGCATAAGGCTATGAAG"
  },
  {
    "no": 120,
    "primer_name": "pBAD-F",
    "primer_sequence": "ATGCCATAGCATTTTTATCC",
    "reverse_sequence": "GGATAAAAATGCTATGGCAT"
  },
  {
    "no": 121,
    "primer_name": "pBAD-R",
    "primer_sequence": "GATTTAATCTGTATCAGG",
    "reverse_sequence": "CCTGATACAGATTAAATC"
  },
  {
    "no": 122,
    "primer_name": "PMIRGLO-SEQF",
    "primer_sequence": "GCGCGGTGGTGTTGTGTTCG",
    "reverse_sequence": "CGAACACAACACCACCGCGC"
  },
  {
    "no": 123,
    "primer_name": "PMIRGLO-SEQR",
    "primer_sequence": "TGTGGTTTGTCCAAACTCA",
    "reverse_sequence": "TGAGTTTGGACAAACCACA"
  },
  {
    "no": 124,
    "primer_name": "PCB2004-F",
    "primer_sequence": "AGAACACGGGGGACTCTA",
    "reverse_sequence": "TAGAGTCCCCCGTGTTCT"
  },
  {
    "no": 125,
    "primer_name": "PCB2004-R",
    "primer_sequence": "ATCGCAAGACCGGCAACA",
    "reverse_sequence": "TGTTGCCGGTCTTGCGAT"
  },
  {
    "no": 126,
    "primer_name": "PSICHECK2-F",
    "primer_sequence": "TCCACTTCAGCCAGGAGGAC",
    "reverse_sequence": "GTCCTCCTGGCTGAAGTGGA"
  },
  {
    "no": 127,
    "primer_name": "PSICHECK2-R",
    "primer_sequence": "GCGAGGTCCGAAGACTCATT",
    "reverse_sequence": "AATGAGTCTTCGGACCTCGC"
  },
  {
    "no": 128,
    "primer_name": "PGWB5-F",
    "primer_sequence": "GGAGAGAACACGGGGGACTC",
    "reverse_sequence": "GAGTCCCCCGTGTTCTCTCC"
  },
  {
    "no": 129,
    "primer_name": "PGWB5-R",
    "primer_sequence": "GGAAATTCGAGCTCGGGCCGC",
    "reverse_sequence": "GCGGCCCGAGCTCGAATTTCC"
  },
  {
    "no": 130,
    "primer_name": "PZ8-1-F",
    "primer_sequence": "ATGTTTTTTGCGCCGACATC",
    "reverse_sequence": "GATGTCGGCGCAAAAAACAT"
  },
  {
    "no": 131,
    "primer_name": "PZ8-1-R",
    "primer_sequence": "TCTGCGTTCTGATTTAATCT",
    "reverse_sequence": "AGATTAAATCAGAACGCAGA"
  },
  {
    "no": 132,
    "primer_name": "HU6-F",
    "primer_sequence": "GAGGGCCTATTTCCCATGATT",
    "reverse_sequence": "AATCATGGGAAATAGGCCCTC"
  },
  {
    "no": 133,
    "primer_name": "PBABE-5",
    "primer_sequence": "CTTTATCCAGCCCTCAC",
    "reverse_sequence": "GTGAGGGCTGGATAAAG"
  },
  {
    "no": 134,
    "primer_name": "PBABE-3",
    "primer_sequence": "ACCCTAACTGACACACATTCC",
    "reverse_sequence": "GGAATGTGTGTCAGTTAGGGT"
  },
  {
    "no": 135,
    "primer_name": "DSRED1-C",
    "primer_sequence": "AGCTGGACATCACCTCCCACAACG",
    "reverse_sequence": "CGTTGTGGGAGGTGATGTCCAGCT"
  },
  {
    "no": 136,
    "primer_name": "DSRED1-N",
    "primer_sequence": "GTACTGGAACTGGGGGGACAG",
    "reverse_sequence": "CTGTCCCCCCAGTTCCAGTAC"
  },
  {
    "no": 137,
    "primer_name": "LUC-F",
    "primer_sequence": "AGTCAAGTAACAACCGCGA",
    "reverse_sequence": "TCGCGGTTGTTACTTGACT"
  },
  {
    "no": 138,
    "primer_name": "IRES-R",
    "primer_sequence": "AACGCACACCGGCCTTATTC",
    "reverse_sequence": "GAATAAGGCCGGTGTGCGTT"
  },
  {
    "no": 139,
    "primer_name": "PHIS2-F",
    "primer_sequence": "AGCTGGCGAAAGGGGGATGT",
    "reverse_sequence": "ACATCCCCCTTTCGCCAGCT"
  },
  {
    "no": 140,
    "primer_name": "PCINT2-F",
    "primer_sequence": "GGCAGTTATTGGTGC",
    "reverse_sequence": "GCACCAATAACTGCC"
  },
  {
    "no": 141,
    "primer_name": "PCDH-R",
    "primer_sequence": "CACGACATCACTTTCCCAGT",
    "reverse_sequence": "ACTGGGAAAGTGATGTCGTG"
  },
  {
    "no": 142,
    "primer_name": "T7-sg-CX-F",
    "primer_sequence": "TGCAAGGCGATTAAGTTGGG",
    "reverse_sequence": "CCCAACTTAATCGCCTTGCA"
  },
  {
    "no": 143,
    "primer_name": "PBI121-SEQF",
    "primer_sequence": "GCAAGTGGATTGATGTGAT",
    "reverse_sequence": "ATCACATCAATCCACTTGC"
  },
  {
    "no": 144,
    "primer_name": "PBI121-SEQR",
    "primer_sequence": "CGCATAATTACGAATATCTG",
    "reverse_sequence": "CAGATATTCGTAATTATGCG"
  },
  {
    "no": 145,
    "primer_name": "PX330-F",
    "primer_sequence": "GCATATACGATACAAGGCTG",
    "reverse_sequence": "CAGCCTTGTATCGTATATGC"
  },
  {
    "no": 146,
    "primer_name": "PX330-R",
    "primer_sequence": "GCTCACCTCGACCATGGTAA",
    "reverse_sequence": "TTACCATGGTCGAGGTGAGC"
  },
  {
    "no": 147,
    "primer_name": "MIGR1-SEQFN",
    "primer_sequence": "GCCCTTTGTACACCCTAAGC",
    "reverse_sequence": "GCTTAGGGTGTACAAAGGGC"
  },
  {
    "no": 148,
    "primer_name": "MSCV-R",
    "primer_sequence": "CAGCGGGGCTGCTAAAGCGCATGC",
    "reverse_sequence": "GCATGCGCTTTAGCAGCCCCGCTG"
  },
  {
    "no": 149,
    "primer_name": "PURO.CRE-SEQR",
    "primer_sequence": "CTACGAGCGGCTCGGCTT",
    "reverse_sequence": "AAGCCGAGCCGCTCGTAG"
  },
  {
    "no": 150,
    "primer_name": "PMDC110-SEQF1",
    "primer_sequence": "AACAAGAATTGGGACAAC",
    "reverse_sequence": "GTTGTCCCAATTCTTGTT"
  },
  {
    "no": 151,
    "primer_name": "PCAG-5",
    "primer_sequence": "CGTGTGACCGGCGGCTCTAGAGCCTC",
    "reverse_sequence": "GAGGCTCTAGAGCCGCCGGTCACACG"
  },
  {
    "no": 152,
    "primer_name": "PCAG-F",
    "primer_sequence": "GCAACGTGCTGGTTATTGTG",
    "reverse_sequence": "CACAATAACCAGCACGTTGC"
  },
  {
    "no": 153,
    "primer_name": "PCB308-F",
    "primer_sequence": "GGTGGCGGCCGCGAGCTCTCTAG",
    "reverse_sequence": "CTAGAGAGCTCGCGGCCGCCACC"
  },
  {
    "no": 154,
    "primer_name": "PCB308-R",
    "primer_sequence": "CACGTTCTACAGGACGTAACAT",
    "reverse_sequence": "ATGTTACGTCCTGTAGAACGTG"
  },
  {
    "no": 155,
    "primer_name": "PCAM1301-NCOI-R",
    "primer_sequence": "TTTACACCATAACCAATCAA",
    "reverse_sequence": "TTGATTGGTTATGGTGTAAA"
  },
  {
    "no": 156,
    "primer_name": "1302-SPEI",
    "primer_sequence": "TTCCGTATGTTGCATCACCT",
    "reverse_sequence": "AGGTGATGCAACATACGGAA"
  },
  {
    "no": 157,
    "primer_name": "PLB-SEQF",
    "primer_sequence": "CGACTCACTATAGGGAGAGCGGC",
    "reverse_sequence": "GCCGCTCTCCCTATAGTGAGTCG"
  },
  {
    "no": 158,
    "primer_name": "PLB-SEQR",
    "primer_sequence": "AAGAACATCGATTTTCCATGGCAG",
    "reverse_sequence": "CTGCCATGGAAAATCGATGTTCTT"
  },
  {
    "no": 159,
    "primer_name": "psmart-seqF",
    "primer_sequence": "TTAAGATTCTTGTACGACGG",
    "reverse_sequence": "CCGTCGTACAAGAATCTTAA"
  },
  {
    "no": 160,
    "primer_name": "psmart-seqR",
    "primer_sequence": "TTATGCTAGTTATTGCTCAG",
    "reverse_sequence": "CTGAGCAATAACTAGCATAA"
  },
  {
    "no": 161,
    "primer_name": "mCherry-F",
    "primer_sequence": "CCCCGTAATGCAGAAGAAGA",
    "reverse_sequence": "TCTTCTTCTGCATTACGGGG"
  },
  {
    "no": 162,
    "primer_name": "pGAP-F",
    "primer_sequence": "GTCCCTATTTCAATCAATTGAA",
    "reverse_sequence": "TTCAATTGATTGAAATAGGGAC"
  },
  {
    "no": 163,
    "primer_name": "PABAI-R",
    "primer_sequence": "ACATGGCAGTTTGGAGGT",
    "reverse_sequence": "ACCTCCAAACTGCCATGT"
  },
  {
    "no": 164,
    "primer_name": "EGFP-N",
    "primer_sequence": "CGTCGCCGTCCAGCTCGACCAG",
    "reverse_sequence": "CTGGTCGAGCTGGACGGCGACG"
  },
  {
    "no": 165,
    "primer_name": "EGFP-C",
    "primer_sequence": "AGCACCCAGTCCGCCCTGAGC",
    "reverse_sequence": "GCTCAGGGCGGACTGGGTGCT"
  },
  {
    "no": 166,
    "primer_name": "PTT5-SEQF",
    "primer_sequence": "TGGCCATACACTTGAGTGAC",
    "reverse_sequence": "GTCACTCAAGTGTATGGCCA"
  },
  {
    "no": 167,
    "primer_name": "PTT5-SEQR",
    "primer_sequence": "CCATATGTCCTTCCGAGTGA",
    "reverse_sequence": "TCACTCGGAAGGACATATGG"
  },
  {
    "no": 168,
    "primer_name": "T3",
    "primer_sequence": "ATTAACCCTCACTAAAGGGA",
    "reverse_sequence": "TCCCTTTAGTGAGGGTTAAT"
  },
  {
    "no": 169,
    "primer_name": "HGH-PA-R",
    "primer_sequence": "TAGAAGGACACCTAGTCAGA",
    "reverse_sequence": "TCTGACTAGGTGTCCTTCTA"
  },
  {
    "no": 170,
    "primer_name": "H1 promoter",
    "primer_sequence": "TCGCTATGTGTTCTGGGAAA",
    "reverse_sequence": "TTTCCCAGAACACATAGCGA"
  },
  {
    "no": 171,
    "primer_name": "BV-F",
    "primer_sequence": "AGTGGTTGGCTACGTATACTCC",
    "reverse_sequence": "GGAGTATACGTAGCCAACCACT"
  },
  {
    "no": 172,
    "primer_name": "PUC57-T7-F",
    "primer_sequence": "TTGTACTGAGAGTGCACCATATG",
    "reverse_sequence": "CATATGGTGCACTCTCAGTACAA"
  },
  {
    "no": 173,
    "primer_name": "mCherry-R",
    "primer_sequence": "TTGGTCACCTTCAGCTTGG",
    "reverse_sequence": "CCAAGCTGAAGGTGACCAA"
  },
  {
    "no": 174,
    "primer_name": "WPRE-R",
    "primer_sequence": "CATAGCGTAAAAGGAGCAACA",
    "reverse_sequence": "TGTTGCTCCTTTTACGCTATG"
  },
  {
    "no": 175,
    "primer_name": "TK-PA-R",
    "primer_sequence": "CTTCCGTGTTTCAGTTAGC",
    "reverse_sequence": "GCTAACTGAAACACGGAAG"
  },
  {
    "no": 176,
    "primer_name": "PGR107-SEQF",
    "primer_sequence": "GGAATCAATCACAGTGTTGG",
    "reverse_sequence": "CCAACACTGTGATTGATTCC"
  },
  {
    "no": 177,
    "primer_name": "PGR107-SEQR",
    "primer_sequence": "TTGAGGTAGTTGACCCTATG",
    "reverse_sequence": "CATAGGGTCAACTACCTCAA"
  },
  {
    "no": 178,
    "primer_name": "pCMV5-Fwd ",
    "primer_sequence": "CGCAAATGGGCGGTAGGCGTG",
    "reverse_sequence": "CACGCCTACCGCCCATTTGCG"
  },
  {
    "no": 179,
    "primer_name": "pCMV5-Rev",
    "primer_sequence": "CCTCCACCCCATAATATTATAGAAGGACAC",
    "reverse_sequence": "GTGTCCTTCTATAATATTATGGGGTGGAGG"
  },
  {
    "no": 180,
    "primer_name": "SBP-primer",
    "primer_sequence": "TCGATGGACGAGAAGACCA",
    "reverse_sequence": "TGGTCTTCTCGTCCATCGA"
  },
  {
    "no": 181,
    "primer_name": "SBP-reverse-primer",
    "primer_sequence": "GGAATGCTCGTCAAGAAGACA",
    "reverse_sequence": "TGTCTTCTTGACGAGCATTCC"
  },
  {
    "no": 182,
    "primer_name": "pSPYC(N)E-F",
    "primer_sequence": "GACGTAAGGGATGACGCAC",
    "reverse_sequence": "GTGCGTCATCCCTTACGTC"
  },
  {
    "no": 183,
    "primer_name": "PSPYNE-R",
    "primer_sequence": "CGCCCTTGCTCACCATAA",
    "reverse_sequence": "TTATGGTGAGCAAGGGCG"
  },
  {
    "no": 184,
    "primer_name": "PSPYCE-R",
    "primer_sequence": "GATGCCGTTCTTCTGCTTGT",
    "reverse_sequence": "ACAAGCAGAAGAACGGCATC"
  },
  {
    "no": 185,
    "primer_name": "PABAI-SEQF",
    "primer_sequence": "GTTCCTTATATGTAGCTTTCGACA",
    "reverse_sequence": "TGTCGAAAGCTACATATAAGGAAC"
  },
  {
    "no": 186,
    "primer_name": "PABAI-SEQR",
    "primer_sequence": "ACATGGCAGTTTGGAGGT",
    "reverse_sequence": "ACCTCCAAACTGCCATGT"
  },
  {
    "no": 187,
    "primer_name": "PRK5-R",
    "primer_sequence": "AAGCTTGGCCGCCATGGCCCAACT",
    "reverse_sequence": "AGTTGGGCCATGGCGGCCAAGCTT"
  },
  {
    "no": 188,
    "primer_name": "5-AD/GAL4AD",
    "primer_sequence": "TACCACTACAATGGATGATG",
    "reverse_sequence": "CATCATCCATTGTAGTGGTA"
  },
  {
    "no": 189,
    "primer_name": "PTRV2-SEQF",
    "primer_sequence": "CCACATATTCGCACGTATGA",
    "reverse_sequence": "TCATACGTGCGAATATGTGG"
  },
  {
    "no": 190,
    "primer_name": "PTRV2-SEQR",
    "primer_sequence": "GACTTACCGATCAATCAAGA",
    "reverse_sequence": "TCTTGATTGATCGGTAAGTC"
  },
  {
    "no": 191,
    "primer_name": "PLIVE-F",
    "primer_sequence": "GCCCTAAAGAGAAATTGG",
    "reverse_sequence": "CCAATTTCTCTTTAGGGC"
  },
  {
    "no": 192,
    "primer_name": "PLIVE-R",
    "primer_sequence": "TGGTCGGTGCTGGTCTAT",
    "reverse_sequence": "ATAGACCAGCACCGACCA"
  },
  {
    "no": 193,
    "primer_name": "AC5-Forward",
    "primer_sequence": "ACACAAAGCCGCTCCATCAG",
    "reverse_sequence": "CTGATGGAGCGGCTTTGTGT"
  },
  {
    "no": 194,
    "primer_name": "pTRC99C-F",
    "primer_sequence": "TTGCGCCGACATCATAAC",
    "reverse_sequence": "GTTATGATGTCGGCGCAA"
  },
  {
    "no": 195,
    "primer_name": "1541R",
    "primer_sequence": "AAGGAGGTGATCCAGCC",
    "reverse_sequence": "GGCTGGATCACCTCCTT"
  },
  {
    "no": 196,
    "primer_name": "RV-M",
    "primer_sequence": "GAGCGGATAACAATTTCACACAGG",
    "reverse_sequence": "CCTGTGTGAAATTGTTATCCGCTC"
  },
  {
    "no": 197,
    "primer_name": "PClone007-SEQF",
    "primer_sequence": "GATCCTTTGATTTTCTAC",
    "reverse_sequence": "GTAGAAAATCAAAGGATC"
  },
  {
    "no": 198,
    "primer_name": "PClone007-SEQR",
    "primer_sequence": "TCGGAGGCTTTTGACTTT",
    "reverse_sequence": "AAAGTCAAAAGCCTCCGA"
  },
  {
    "no": 199,
    "primer_name": "PRM1-SEQR",
    "primer_sequence": "ACACGGTGCCTGACTGCGTT",
    "reverse_sequence": "AACGCAGTCAGGCACCGTGT"
  },
  {
    "no": 200,
    "primer_name": "PZR606-SEQF",
    "primer_sequence": "TCTAGACTGCGATGAGTG",
    "reverse_sequence": "CACTCATCGCAGTCTAGA"
  },
  {
    "no": 201,
    "primer_name": "PZR606-SEQR",
    "primer_sequence": "CCTTCACCCTCTCCACTG",
    "reverse_sequence": "CAGTGGAGAGGGTGAAGG"
  },
  {
    "no": 202,
    "primer_name": "HBG-PCAG-R",
    "primer_sequence": "TGTCCCCATAATTTTTGGCAGAGG",
    "reverse_sequence": "CCTCTGCCAAAAATTATGGGGACA"
  },
  {
    "no": 203,
    "primer_name": "HBG-PCAG-F",
    "primer_sequence": "TCGGCTTCTGGCGTGTGACC",
    "reverse_sequence": "GGTCACACGCCAGAAGCCGA"
  },
  {
    "no": 204,
    "primer_name": "F8",
    "primer_sequence": "TTGATCCTGCCGGAGGCCATTG",
    "reverse_sequence": "CAATGGCCTCCGGCAGGATCAA"
  },
  {
    "no": 205,
    "primer_name": "R1462",
    "primer_sequence": "ATCCAGCCGCAGATTCCCCTAC",
    "reverse_sequence": "GTAGGGGAATCTGCGGCTGGAT"
  },
  {
    "no": 206,
    "primer_name": "S129605-F",
    "primer_sequence": "CAGTGCAGGGGAAAGAATAGTAGAC",
    "reverse_sequence": "GTCTACTATTCTTTCCCCTGCACTG"
  },
  {
    "no": 207,
    "primer_name": "p10-Promoter",
    "primer_sequence": "CGGACCTTTAATTCAACCC",
    "reverse_sequence": "GGGTTGAATTAAAGGTCCG"
  },
  {
    "no": 208,
    "primer_name": "366PCMV-F",
    "primer_sequence": "ATAGAAACTGGGCTTGTC",
    "reverse_sequence": "GACAAGCCCAGTTTCTAT"
  },
  {
    "no": 209,
    "primer_name": "366PCMV-R",
    "primer_sequence": "GTCAGCTTGCCGTAGGTG",
    "reverse_sequence": "CACCTACGGCAAGCTGAC"
  },
  {
    "no": 210,
    "primer_name": "1541R",
    "primer_sequence": "AAGGAGGTGATCCAGCC",
    "reverse_sequence": "GGCTGGATCACCTCCTT"
  },
  {
    "no": 211,
    "primer_name": "1102-SFB-SEQF",
    "primer_sequence": "AGGCTGGAGCACCACCCTCAG",
    "reverse_sequence": "CTGAGGGTGGTGCTCCAGCCT"
  },
  {
    "no": 212,
    "primer_name": "1102-SFB-seqR",
    "primer_sequence": "CGCACACCGGCCTTATTCCAAGC",
    "reverse_sequence": "GCTTGGAATAAGGCCGGTGTGCG"
  },
  {
    "no": 213,
    "primer_name": "P5825",
    "primer_sequence": "GCTCATCCACCAAGAAGCCT",
    "reverse_sequence": "AGGCTTCTTGGTGGATGAGC"
  },
  {
    "no": 214,
    "primer_name": "P5826",
    "primer_sequence": "GCAGGCTAGGGAGATTGCAT",
    "reverse_sequence": "ATGCAATCTCCCTAGCCTGC"
  },
  {
    "no": 215,
    "primer_name": "P5831",
    "primer_sequence": "GGGGACTCTGTAAGCCACTG",
    "reverse_sequence": "CAGTGGCTTACAGAGTCCCC"
  },
  {
    "no": 216,
    "primer_name": "P5832",
    "primer_sequence": "ACCCAAGTGCCAGTGATGTT",
    "reverse_sequence": "AACATCACTGGCACTTGGGT"
  },
  {
    "no": 217,
    "primer_name": "PLVX-mcherry-N1-R ",
    "primer_sequence": "GCCACCCTTGGTCACCTTCA",
    "reverse_sequence": "TGAAGGTGACCAAGGGTGGC"
  },
  {
    "no": 218,
    "primer_name": "1495R",
    "primer_sequence": "CTACGGCTACCTTGTTACGA ",
    "reverse_sequence": " TCGTAACAAGGTAGCCGTAG"
  },
  {
    "no": 219,
    "primer_name": "H11-seqF1",
    "primer_sequence": "TTACTGGCACAATGTTAATCCAGC",
    "reverse_sequence": "GCTGGATTAACATTGTGCCAGTAA"
  },
  {
    "no": 220,
    "primer_name": "H11-seqF2",
    "primer_sequence": "CTAGAGCAAGGCCAGCCAGA",
    "reverse_sequence": "TCTGGCTGGCCTTGCTCTAG"
  },
  {
    "no": 221,
    "primer_name": "H11-seqF3",
    "primer_sequence": "CTAGAGCAAGGCCAGCCAGA",
    "reverse_sequence": "TCTGGCTGGCCTTGCTCTAG"
  },
  {
    "no": 222,
    "primer_name": "H11-seqR1",
    "primer_sequence": "CTTTACATTCAATTTATAATACCAG",
    "reverse_sequence": "CTGGTATTATAAATTGAATGTAAAG"
  },
  {
    "no": 223,
    "primer_name": "H11-SEQR2",
    "primer_sequence": "TCACATCTTTCCAGTCCCAAATG",
    "reverse_sequence": "CATTTGGGACTGGAAAGATGTGA"
  },
  {
    "no": 224,
    "primer_name": "H11-seqR3",
    "primer_sequence": "CTCATTTAGACTGTCTTAGT",
    "reverse_sequence": "ACTAAGACAGTCTAAATGAG"
  },
  {
    "no": 225,
    "primer_name": "H11-SEQF1",
    "primer_sequence": "TTACTGGCACAATGTTAATCCAGC",
    "reverse_sequence": "GCTGGATTAACATTGTGCCAGTAA"
  },
  {
    "no": 226,
    "primer_name": "H11-SEQR1",
    "primer_sequence": "CTTTACATTCAATTTATAATACCAG",
    "reverse_sequence": "CTGGTATTATAAATTGAATGTAAAG"
  },
  {
    "no": 227,
    "primer_name": "H11-SEQF2",
    "primer_sequence": "CTAGAGCAAGGCCAGCCAGA",
    "reverse_sequence": "TCTGGCTGGCCTTGCTCTAG"
  },
  {
    "no": 228,
    "primer_name": "H11-SEQR2",
    "primer_sequence": "TCACATCTTTCCAGTCCCAAATG",
    "reverse_sequence": "CATTTGGGACTGGAAAGATGTGA"
  },
  {
    "no": 229,
    "primer_name": "LAR3",
    "primer_sequence": "CACAACGGGTTCTTCTGTTAGTCC",
    "reverse_sequence": "GGACTAACAGAAGAACCCGTTGTG"
  },
  {
    "no": 230,
    "primer_name": "NEO-3F",
    "primer_sequence": "TCTGAGGCGGAAAGAACCAG",
    "reverse_sequence": "CTGGTTCTTTCCGCCTCAGA"
  },
  {
    "no": 231,
    "primer_name": "ZMK-2F4",
    "primer_sequence": "GCATCGCATTGTCTGAGTAGGTG",
    "reverse_sequence": "CACCTACTCAGACAATGCGATGC"
  },
  {
    "no": 232,
    "primer_name": "PUC57-SEQ1",
    "primer_sequence": "GGTGCGGGCCTCTTCGCTAT",
    "reverse_sequence": "ATAGCGAAGAGGCCCGCACC"
  },
  {
    "no": 233,
    "primer_name": "PUC57-T7-F",
    "primer_sequence": "TTGTACTGAGAGTGCACCATATG",
    "reverse_sequence": "CATATGGTGCACTCTCAGTACAA"
  },
  {
    "no": 234,
    "primer_name": "PL253-TR",
    "primer_sequence": "ATATGCGAAGTGGACCTGGG",
    "reverse_sequence": "CCCAGGTCCACTTCGCATAT"
  },
  {
    "no": 235,
    "primer_name": "PL253-TR1",
    "primer_sequence": "TCGGTGTTCGAGGCCACACG",
    "reverse_sequence": "CGTGTGGCCTCGAACACCGA"
  },
  {
    "no": 236,
    "primer_name": "PEF-F",
    "primer_sequence": "TCAAGCCTCAGACAGTGGTTC",
    "reverse_sequence": "GAACCACTGTCTGAGGCTTGA"
  },
  {
    "no": 237,
    "primer_name": "PEF-R",
    "primer_sequence": "GCATCACAAATTTCACAAATAAAGC",
    "reverse_sequence": "GCTTTATTTGTGAAATTTGTGATGC"
  },
  {
    "no": 238,
    "primer_name": "PBI221-NE-F",
    "primer_sequence": "AGGACGGCAACATCCTG",
    "reverse_sequence": "CAGGATGTTGCCGTCCT"
  },
  {
    "no": 239,
    "primer_name": "PBI221-NE-R",
    "primer_sequence": "tcatcgcaagaccggca",
    "reverse_sequence": "tgccggtcttgcgatga"
  },
  {
    "no": 240,
    "primer_name": "PBI221-CE-F",
    "primer_sequence": "GTTGAAGATGCCTCTGCCG",
    "reverse_sequence": "CGGCAGAGGCATCTTCAAC"
  },
  {
    "no": 241,
    "primer_name": "PBI221-CE-R",
    "primer_sequence": "TTACTTGTACAGCTCGTCC",
    "reverse_sequence": "GGACGAGCTGTACAAGTAA"
  },
  {
    "no": 242,
    "primer_name": "PQLL-SEQF",
    "primer_sequence": "TGATTTTCTACCGAAGAAAGGCC",
    "reverse_sequence": "GGCCTTTCTTCGGTAGAAAATCA"
  },
  {
    "no": 243,
    "primer_name": "RTW",
    "primer_sequence": "AACGACCGAGCGCAGCG",
    "reverse_sequence": "CGCTGCGCTCGGTCGTT"
  },
  {
    "no": 244,
    "primer_name": "PQLL-seqR",
    "primer_sequence": "TCAAGTCAAAAGCCTCCGGTC",
    "reverse_sequence": "GACCGGAGGCTTTTGACTTGA"
  },
  {
    "no": 245,
    "primer_name": "1510R",
    "primer_sequence": "ACGGYTACCTTGTTACGACTT",
    "reverse_sequence": "AAGTCGTAACAAGGTAYCCGT"
  },
  {
    "no": 246,
    "primer_name": "7F",
    "primer_sequence": "AGAGTTTGATYMTGGCTCAG",
    "reverse_sequence": "CTGAGCCAMYATCAAACTCT"
  }
]